export default "__VITE_PUBLIC_ASSET__5e66e35c__"